import { css } from '@emotion/react';

export const modalStyle = css`
  max-height: 80vh;
  height: 100%;
`;
